import React, { useState } from 'react'

import { CaseCard } from '../components/CaseCard'
import { scoreCase } from '../helpers/cases'
import { systemMatchesAllFilters } from '../helpers/systems'
import { useFiltersStore } from '../state/filtersStore'
import { useWpDataStore } from '../state/wpDataStore'

const PAGE_SIZE = 10

const CasesTab = () => {
  const appliedFilters = useFiltersStore((s) => s.appliedFilters)

  const { cases, systems, loading, error } = useWpDataStore()

  if (loading && error) return null

  const systemFilters = appliedFilters.filter((f) => f.applies_to === 'systems')
  const caseFilters = appliedFilters.filter((f) => f.applies_to === 'cases')

  // Get systems that matches all applied filters = shortlist
  const filteredSystems =
    systems?.filter((sys) => systemMatchesAllFilters(sys, systemFilters)) ?? []
  const matchingSystemIds = new Set(filteredSystems.map((s) => s.id))

  // And pass the ids to the scoring function
  const sortedCases =
    cases
      ?.map((c) => ({
        casePost: c,
        score: scoreCase(c, caseFilters, matchingSystemIds),
      }))
      .sort((a, b) => b.score - a.score || a.casePost.id - b.casePost.id) // stable-ish tie-break
      .map((x) => x.casePost) ?? []

  const [visibleCount, setVisibleCount] = useState(PAGE_SIZE)
  const visibleCases = sortedCases.slice(0, visibleCount)
  const canShowMore = visibleCount < sortedCases.length

  return (
    <div>
      {!sortedCases?.length ? (
        <p>No case studies found.</p>
      ) : (
        <>
          <ul className='case-list'>
            <ul>
              {visibleCases.map((casePost) => {
                const { id } = casePost

                return (
                  <li key={id} className='case-list__item'>
                    <CaseCard casePost={casePost} />
                  </li>
                )
              })}
            </ul>
          </ul>

          {canShowMore && (
            <button
              type='button'
              onClick={() => setVisibleCount((c) => c + PAGE_SIZE)}
            >
              Show more cases
            </button>
          )}
        </>
      )}
    </div>
  )
}

export { CasesTab }
